module.exports = __webpack_public_path__ + "asset/agm-notification-and-agenda-form--2936be.png";